import { createFileRoute } from '@tanstack/react-router';
import { VoucherSetupPage } from '@/features/marketing';

/** A voucher campaign's setup — `/marketing/campaigns/{id}/voucher` (its offer, form and rules; its flyer and text live in the page editor). */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/voucher')({
  component: VoucherSetupRoute,
});

function VoucherSetupRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <VoucherSetupPage orgId={orgId} campaignId={campaignId} />;
}
